module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$hydrowareSecurityJS.canView_P('personnel') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Personnel"
    }
  })], 1) : _c('div', {
    staticClass: "add_personal"
  }, [_c('div', {
    staticClass: "x_panel tile "
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "90px"
    }
  }, [(this.$hydrowareCommonJS.showInnerPageHeading) ? _c('div', {
    staticClass: "x_title",
    staticStyle: {
      "border": "inherit !important"
    }
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "32px !important"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control hydroware-search-table-field",
    attrs: {
      "type": "text",
      "placeholder": "Search",
      "aria-describedby": "basic-addon1"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeinactive),
      expression: "includeinactive"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "id": "check1"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeinactive) ? _vm._i(_vm.includeinactive, null) > -1 : (_vm.includeinactive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeinactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeinactive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeinactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeinactive = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$hydrowareSecurityJS.canAdd_P('personnel') == true),
      expression: "$hydrowareSecurityJS.canAdd_P('personnel')==true"
    }],
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "color": "#6dc8f4",
      "border-color": "rgb(109, 200, 244)"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPopup('addPersonal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n                Add Personnel\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticStyle: {
      "font-size": "large",
      "padding-left": "10px"
    }
  }, [_vm._v("Profiles: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white",
      "font-size": "large"
    }
  }, [_vm._v(_vm._s(_vm.activecount) + " Active")]), _vm._v(" "), (_vm.includeinactive) ? _c('span', {
    staticStyle: {
      "color": "white",
      "font-size": "large",
      "padding-left": "10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.inactivecount) + " Inactive")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 sol-sm-12 col-xs-12"
  }, _vm._l((_vm.filtereddata), function(item) {
    return (!item.IsActive == _vm.includeinactive || item.IsActive) ? _c('div', {
      staticClass: "col-lg-3  col-md-4 col-sm-4 col-xs-12",
      style: ({
        'margin-top': item.FirstName ? '20px' : ''
      })
    }, [(item) ? _c('div', {
      staticClass: "card-1 card col-md-12 col-lg-12 col-sm-12 col-xs-12"
    }, [(item.IsActive) ? _c('div', [_c('span', {
      staticClass: "onlinespan"
    }, [_vm._v("Active")]), _vm._v(" "), _c('div', {
      staticClass: "online"
    })]) : _c('div', [_c('span', {
      staticClass: "offlinespan"
    }, [_vm._v("Inactive")]), _vm._v(" "), _c('div', {
      staticClass: "offline"
    })]), _vm._v(" "), _c('img', {
      staticClass: "poligon",
      staticStyle: {
        "width": "90px",
        "height": "80px",
        "top": "12px"
      },
      attrs: {
        "src": item.ImagePath ? _vm.imageurl + '' + item.ImagePath : 'static/images/Default-avatar.jpg',
        "alt": "John",
        "onerror": "this.src='static/images/Default-avatar.jpg'"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('p', {
      staticClass: "usercard-name elepsis"
    }, [_vm._v(_vm._s(_vm._f("formatcase")(item.FirstName)) + " " + _vm._s(_vm._f("formatcase")(item.LastName)))])]), _vm._v(" "), (item.PhoneNumber && _vm.$hydrowareSecurityJS.canView_A('personnelbasicinfo')) ? _c('span', {
      staticClass: "usercard-details elepsis"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(_vm._f("phoneformat")(item.PhoneNumber)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!item.PhoneNumber) ? _c('div', {
      staticStyle: {
        "height": "18px"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$hydrowareSecurityJS.canView_A('personnelbasicinfo')) ? _c('p', {
      staticClass: "usercard-details elepsis"
    }, [_c('i', {
      staticClass: "fa fa-envelope"
    }), _vm._v(" " + _vm._s(item.Email))]) : _vm._e(), _vm._v(" "), _c('CENTER', [_c('span', {
      staticClass: "usercard-highlight elepsis",
      staticStyle: {
        "color": "#6dc8f4"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v("\n                " + _vm._s(item.Location))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$hydrowareSecurityJS.canView_A('personneljobinfo')) ? _c('span', {
      staticClass: "usercard-highlight  elepsis",
      staticStyle: {
        "color": "#6dc8f4"
      }
    }, [_vm._v("\n                        " + _vm._s(item.Position) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', {}, [(_vm.displayViewProfileButton(item)) ? _c('button', {
      staticClass: "btn btn-default btn-lg",
      staticStyle: {
        "padding": "10px 40px",
        "color": "#6dc8f4",
        "border-color": "rgb(109, 200, 244)"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.viewProfile(item)
        }
      }
    }, [_vm._v("\n                      View Profile \n                    ")]) : _vm._e()])], 1) : _vm._e()]) : _vm._e()
  }), 0)])]), _vm._v(" "), (!_vm.filtereddata.length) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(3)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "Addpersonelmodel",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('el-form', {
    ref: "addPersonal",
    attrs: {
      "model": _vm.addPersonal,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "label-width": "100px",
      "spellcheck": "false"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12 col-sm-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "First Name:",
      "prop": "fname"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "todo-field",
      "el:avatar": ""
    },
    model: {
      value: (_vm.addPersonal.fname),
      callback: function($$v) {
        _vm.$set(_vm.addPersonal, "fname", $$v)
      },
      expression: "addPersonal.fname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12 col-sm-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Last Name:",
      "prop": "lname"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addPersonal.lname),
      callback: function($$v) {
        _vm.$set(_vm.addPersonal, "lname", $$v)
      },
      expression: "addPersonal.lname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12 col-sm-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email:",
      "prop": "email"
    }
  }, [_c('el-input', {
    ref: "email",
    model: {
      value: (_vm.addPersonal.email),
      callback: function($$v) {
        _vm.$set(_vm.addPersonal, "email", $$v)
      },
      expression: "addPersonal.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12 col-sm-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone:",
      "prop": "phone"
    }
  }, [_c('el-input', {
    nativeOn: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.addPersonal.phone),
      callback: function($$v) {
        _vm.$set(_vm.addPersonal, "phone", $$v)
      },
      expression: "addPersonal.phone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12 col-sm-12"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "Positions:",
      "prop": "position"
    }
  }, [_c('el-select', {
    staticClass: "hydroware",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Please select",
      "size": "large"
    },
    model: {
      value: (_vm.addPersonal.position),
      callback: function($$v) {
        _vm.$set(_vm.addPersonal, "position", $$v)
      },
      expression: "addPersonal.position"
    }
  }, _vm._l((_vm.positions), function(item) {
    return _c('el-option', {
      key: item.PositionId,
      staticClass: "hydrowarePositionChoice",
      attrs: {
        "disabled": _vm.$hydrowareSecurityJS.disablePositionSelectable_P('add', item),
        "label": item.PositionName,
        "value": item.PositionId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-xs-12 col-sm-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aquatic Facility:",
      "prop": "location"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select",
      "size": "large"
    },
    model: {
      value: (_vm.addPersonal.location),
      callback: function($$v) {
        _vm.$set(_vm.addPersonal, "location", $$v)
      },
      expression: "addPersonal.location"
    }
  }, _vm._l((_vm.locations), function(item) {
    return _c('el-option', {
      key: item.LocationId,
      attrs: {
        "label": item.LocationName,
        "value": item.LocationId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-xs-12 col-sm-12"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "label": "",
      "prop": "IsAppUser"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "disabled": _vm.licenceActive == true
    },
    model: {
      value: (_vm.addPersonal.IsAppUser),
      callback: function($$v) {
        _vm.$set(_vm.addPersonal, "IsAppUser", $$v)
      },
      expression: "addPersonal.IsAppUser"
    }
  }, [_vm._v("App User")])], 1)], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "color": "gray",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.buttonclicked
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('addPersonal')
      }
    }
  }, [_vm._v("Create\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('b', [_vm._v("Personnel List")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden-sm hidden-md hidden-lg hidden-xl"
  }, [_c('br'), _vm._v("  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "padding-top": "13px",
      "font-size": "1.2em",
      "width": "auto"
    },
    attrs: {
      "for": "check1"
    }
  }, [_vm._v("\n                      Include Inactive\n                      "), _c('div', {
    staticStyle: {
      "border": "1px solid #B5DEF4 !important"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "padding-top": "4px",
      "background-color": "#B5DEF4",
      "color": "white",
      "font-size": "13px",
      "padding": "2px"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("No Results Found!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Add Personnel")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9637eaba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/addpersonnel/addpersonnel.vue
// module id = 839
// module chunks = 1